<template>
  <section class="container py-5">
    <h2 class="mb-4 text-center">Avis sur l’offre</h2>

    <div v-if="loading" class="text-center">Chargement...</div>

    <div v-else-if="avisList.length === 0" class="text-center text-muted">
      Aucun avis pour cette offre.
    </div>
    <div v-else class="row">
      <div v-for="(a, index) in avisList" :key="index" class="col-md-6 mb-4">
        <div class="card shadow-sm border-0 h-100">
          <div class="card-body">
            <h5 class="card-title">{{ a.prenom }} {{ a.nom }}</h5>
            <p class="text-muted fst-italic mb-3">
              Commentaire : "{{ a.commentaire }}"
            </p>
            <p class="text-end text-secondary">
              <small>Posté le {{ formatDate(a.dateCommentaire) }}</small>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import ApiService from "@/services/ApiService";

export default defineComponent({
  name: "AvisOffre",
  setup() {
    const route = useRoute();
    const avisList = ref<any[]>([]);
    const loading = ref(true);

    const fetchAvis = async () => {
      try {
        const { data } = await ApiService.get(`/offres/${route.params.id}/avis`);
        console.log('tu vas ou', data)
        avisList.value = data; // si ton backend renvoie { code, message, data }
      } catch (error) {
        console.error(error);
      } finally {
        loading.value = false;
      }
    };

    const formatDate = (date: string) => new Date(date).toLocaleDateString();

    onMounted(fetchAvis);

    return { avisList, loading, formatDate };
  },
});
</script>
